import './assets/styles/App.css';
import { Admin, Resource, ListGuesser,EditButton, DeleteButton,EditGuesser } from 'react-admin'
import { ApiShow } from './screens/Apis/ApiShow';
import { ApiList } from './screens/Apis/ApiList';
import { ApiCreate } from './screens/Apis/ApiCreate';
import { ApiEdit } from './screens/Apis/ApiEdit';

import { KeywordShow } from './screens/Keywords/KeywordShow';
import { KeywordList } from './screens/Keywords/KeywordList';
import { KeywordCreate } from './screens/Keywords/KeywordCreate';
import { KeywordEdit } from './screens/Keywords/KeywordEdit';

import Dashboard from './screens/Dashboard';
import { AdminIdentity } from './identity/AdminIdentity';
import { checkbrandAuthProvider } from './providers/CheckBrandAuthProvider';
import { checkbrandDataProvider } from './providers/CheckBrandDataProvider';
import { checkbrandTheme } from './themes/checkbrand-default/CheckBrandTheme';
//import { title } from 'process';

const App = () => {
  let x = new AdminIdentity();
  return (
    <Admin
      title="CheckBrand Administration"
      theme={checkbrandTheme}
      dashboard={Dashboard}
      authProvider={checkbrandAuthProvider}
      dataProvider={checkbrandDataProvider}>
      <Resource name="apis" options={{label:"Apis"}} show={ApiShow} edit={ApiEdit} list={ApiList} create={ApiCreate} />
      <Resource name="keywords" options={{label:"Keywords"}} show={KeywordShow} edit={KeywordEdit} list={KeywordList} create={KeywordCreate} />
     </Admin>
  );
}

export default App;